var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.86878 17.7239C8.86878 16.0004 10.266 14.6032 11.9895 14.6032C13.713 14.6032 15.1102 16.0004 15.1102 17.7239V21.8849H8.86878V17.7239Z",
    stroke: "#67A0C2",
    strokeWidth: 1.56035
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.58716 7.32162C1.58716 6.17262 2.51861 5.24116 3.66762 5.24116H6.05853C6.53094 5.24116 6.98929 5.08038 7.35819 4.78527L10.6898 2.11996C11.4496 1.5121 12.5293 1.5121 13.2891 2.11996L16.6208 4.78527C16.9897 5.08038 17.448 5.24116 17.9204 5.24116H20.3113C21.4603 5.24116 22.3918 6.17262 22.3918 7.32162V19.8044C22.3918 20.9534 21.4603 21.8849 20.3113 21.8849H3.66762C2.51861 21.8849 1.58716 20.9534 1.58716 19.8044V7.32162Z",
    stroke: "#67A0C2",
    strokeWidth: 1.56035
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0699 9.40209C14.0699 8.25308 13.1385 7.32162 11.9895 7.32162C10.8405 7.32162 9.90901 8.25308 9.90901 9.40209C9.90901 10.5511 10.8405 11.4826 11.9895 11.4826C13.1385 11.4826 14.0699 10.5511 14.0699 9.40209Z",
    stroke: "#67A0C2",
    strokeWidth: 1.56035
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCity);
export default __webpack_public_path__ + "static/media/city.107aea6bad997e455262ab65c6e9fe34.svg";
export { ForwardRef as ReactComponent };